












































































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import { UserApi, User } from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import LifecycleModule from '@/store/modules/lifecycle';
import SystemModule from '@/store/modules/system';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import MarketUtil from '@/util/MarketUtil';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import Format from '@/util/Format';
import PartnerUtil from '@/util/PartnerUtil';
import PermissionMixin from '../../../../mixins/PermissionMixin';

@Component({
  components: {
    Dropdown,
    Textfield,
  },
})
export default class ContactInformation extends mixins(PermissionMixin) {
  @Prop({ default: '56px' }) public height!: string;

  @Prop({ default: '531px' }) public width!: string;

  @Prop({}) public isNew!: boolean;

  @PropSync('contactInfo', {}) contactInfoSync!: any;

  private usersList: User[] = [];

  private loading:boolean = false;

  private errors:string = '';

  nameRules = [
    (v: any) => !!v || 'Owner Name is required',
  ];

  public mounted() {
    this.getUsers();
  }

  public async getUsers() {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const api = new UserApi(AppModule.apiConfig);
          const users = await api.getUsers();
          ((this.usersList) as any) = PartnerUtil.usersListFormatted(users.data);
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  get onBoardingPartnerID() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return UserModule.currentPartner.id;
    }
    return null;
  }

  firstNameRules = [
    (v: any) => !!v || 'First Name is required',
    (v: any) => v.length <= 40 || 'First Name must be less than 80 characters',
    (last:any) => /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/.test(last)
    || 'First Name should contain only letters',
  ];

  lastNameRules = [
    (v: any) => !!v || 'Last Name is required',
    (v: any) => v.length <= 80 || 'Last Name must be less than 80 characters',
    (last:any) => /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/.test(last)
    || 'Last Name should contain only letters',
  ];

  titleRules = [
    (v:any) => /^[a-zA-Z-,]*(\s{0,1}[a-zA-Z-, ])*$/.test(v)
    || 'Title should contain only letters',
  ];

  emailRules = [
    (v: any) => !!v || 'E-mail is required for users to access their account',
    (email: any) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
    || 'Email must be valid',
  ];

  phoneRules = [
    (phone: any) => !!phone || 'Contact Number is required',
    (phone: any) => phone.length >= 5 || 'Contact number must be in the format (123) 456-7890',
    (phone: any) => /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g.test(
      phone,
    ) || 'Contact number must be in the format (123) 456-7890',
  ];
}
